import ModelUtil from '@leverege/model-util';
import SolidGraphBackgroundModel from "./background/SolidGraphBackgroundModel.js";
import DotGlyphModel from "./glyph/DotGlyphModel.js";
const TYPE = 'graph.XYChart';
const DEFAULT_MARGIN = {
  top: 10,
  right: 50,
  bottom: 60,
  left: 75
};
function create(extend) {
  return {
    type: TYPE,
    width: null,
    height: null,
    margin: DEFAULT_MARGIN,
    labelOffsets: {
      y: 35
    },
    orientation: 'vertical',
    xAxisPosition: 'bottom',
    yAxisPosition: 'left',
    xCoordinate: null,
    yCoordinate: null,
    threshold: null,
    thresholds: [],
    background: SolidGraphBackgroundModel.create(),
    seriesType: null,
    rollover: {
      detail: null,
      rolloverVisible: true,
      snapToDatumX: true,
      snapToDatumY: true,
      showVerticalCrosshair: false,
      showHorizontalCrosshair: false,
      glyph: DotGlyphModel.create()
    },
    ...extend
  };
}
const thresholdsAccessors = {
  ...ModelUtil.createAllArray('thresholds')
};
export default {
  create,
  TYPE,
  getMargin: ModelUtil.createGetValue('margin'),
  ...ModelUtil.createAllValue('labelOffsets/x', 'xLabelOffset'),
  ...ModelUtil.createAllValue('labelOffsets/y', 'yLabelOffset'),
  ...ModelUtil.createAllValue('margin/top', 'topMargin'),
  ...ModelUtil.createAllValue('margin/right', 'rightMargin'),
  ...ModelUtil.createAllValue('margin/bottom', 'bottomMargin'),
  ...ModelUtil.createAllValue('margin/left', 'leftMargin'),
  ...ModelUtil.createAllValue('orientation'),
  ...ModelUtil.createAllValue('xAxisPosition'),
  ...ModelUtil.createAllValue('yAxisPosition'),
  ...ModelUtil.createAllValue('width'),
  ...ModelUtil.createAllValue('height'),
  ...ModelUtil.createAllValue('xCoordinate'),
  ...ModelUtil.createAllValue('yCoordinate'),
  ...ModelUtil.createAllValue('threshold'),
  ...thresholdsAccessors,
  addThreshold(model, ...rest) {
    // If we add a threshold to the thresholds array, remove our old threshold
    const nModel = {
      ...model,
      threshold: null
    };
    return thresholdsAccessors.addThreshold(nModel, ...rest);
  },
  setThresholds(model, ...rest) {
    // If we add a threshold to the thresholds array, remove our old threshold
    const nModel = {
      ...model,
      threshold: null
    };
    return thresholdsAccessors.setThresholds(nModel, ...rest);
  },
  ...ModelUtil.createAllValue('background'),
  ...ModelUtil.createAllValue('seriesType'),
  ...ModelUtil.createAllValue('rollover/detail', 'rollover'),
  ...ModelUtil.createAllValue('rollover/Visible', 'rolloverVisible'),
  ...ModelUtil.createAllValue('rollover/snapToDatumX', 'snapToDatumX'),
  ...ModelUtil.createAllValue('rollover/snapToDatumY', 'snapToDatumY'),
  ...ModelUtil.createAllValue('rollover/showVerticalCrosshair', 'showVerticalCrosshair'),
  ...ModelUtil.createAllValue('rollover/showHorizontalCrosshair', 'showHorizontalCrosshair'),
  ...ModelUtil.createAllValue('rollover/glyph', 'glyph')
};